// extracted by mini-css-extract-plugin
export default {"tableContainer":"PendingPaymentsTable_tableContainer__FvNEt"};